/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import { compose } from 'lodash/fp';
import Hero from './Hero';
import RichFilteringGrid from './RichFilteringGrid';
import { withConsumer } from '../../../contexts';
import { RichFilteringConsumer } from '../../../contexts/RichFilteringContext';
import { SafePureComponent } from '../../../utils/SafePureComponent';

// TODO: be sure that defaultData isEmpty when integration
export const defaultData = {
  BackgroundColor: { fields: { Value: { value: 'transparent' } } },
  BodyDescription: { value: 'My Body Description' },
  DisclaimerPriceText: { value: 'My disclaimer Text' },
  DisclaimerPriceTooltip: { value: 'My disclaimer tooltip' },
  Headline: { value: 'Results' },
  RichFiltering: true,
  NoResults: {
    Title: { value: 'No Results Title' },
    DescriptionLine1: { value: 'No Results Description Line 1' },
    DescriptionLine2: { value: 'No Results Description line 2' },
  },
  ZoomOutMap: { value: 7 },
  ZoomInMap: { value: 10 },
  Filters: {
    Brands: {
      items: [
        {
          fields: {
            Label: {
              value: 'Regus',
            },
            RawValue: {
              value: 'regus',
            },
            Description: {
              value: 'regus Description',
            },
          },
        },
        {
          fields: {
            Label: {
              value: 'Spaces',
            },
            RawValue: {
              value: 'spaces',
            },
            Description: {
              value: 'spaces Description',
            },
          },
        },
        {
          fields: {
            Label: {
              value: 'HQ',
            },
            RawValue: {
              value: 'hq',
            },
            Description: {
              value: 'hq Description',
            },
          },
        },
        {
          fields: {
            Label: {
              value: 'Signature',
            },
            RawValue: {
              value: 'signature',
            },
            Description: {
              value: 'signature Description',
            },
          },
        },
        {
          fields: {
            Label: {
              value: 'No 18',
            },
            RawValue: {
              value: 'no_18',
            },
            Description: {
              value: 'no 18 Description',
            },
          },
        },
      ],
    },
    Solutions: {
      items: [
        {
          Label: {
            value: 'Office Space',
          },
          RawValue: {
            value: '/office-space',
          },
        },
        {
          Label: {
            value: 'Coworking',
          },
          RawValue: {
            value: '/coworking',
          },
        },
        {
          Label: {
            value: 'Virtual Office',
          },
          RawValue: {
            value: '/virtual-office',
          },
        },
        {
          Label: {
            value: 'Meeting Rooms',
          },
          RawValue: {
            value: '/meeting-rooms',
          },
        },
      ],
    },
    Sorting: {
      items: [
        {
          RawValue: { value: 'asc' },
          Label: { value: 'Price: low to high' },
        },
        {
          RawValue: { value: 'desc' },
          Label: { value: 'Price: high to low' },
        },
        {
          RawValue: { value: 'near' },
          Label: { value: 'Distance: nearest to furthest' },
        },
        {
          RawValue: { value: 'far' },
          Label: { value: 'Distance: furthest to nearest' },
        },
      ],
    },
  },
};

class RichFiltering extends SafePureComponent {
  constructor(props) {
    super(props);

    this.flagEnableComponent = get(
      this.props,
      'fields.RichFiltering.value',
      false,
    );

    this.fields = defaultsDeep(this.props.fields, defaultData);
  }

  componentDidMount() {
    if (!this.flagEnableComponent) return null;

    const { richFilteringContext } = this.props;
    const { storeUrlParams } = richFilteringContext.actions;

    storeUrlParams();
  }

  safeRender() {
    const { BackgroundColor, Headline, BodyDescription, Filters } = this.fields;

    const heroProps = {
      BackgroundColor,
      BodyDescription,
      Filters,
      Headline,
    };

    if (!this.flagEnableComponent) return null;

    return (
      <React.Fragment>
        <Hero fields={heroProps}></Hero>
        <RichFilteringGrid
          fields={this.fields}
          rendering={this.props.rendering}
        />
      </React.Fragment>
    );
  }
}

RichFiltering.displayName = 'RichFiltering';

export default compose(
  withConsumer(RichFilteringConsumer, 'richFilteringContext'),
)(RichFiltering);
